export const IconTriangleRight = () => (
  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dd)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 19.9999L18 11.9999L4 4L4 19.9999Z"
        stroke="url(#paint0_linear)"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd"
        x="0.5"
        y="0.138412"
        width="23.5078"
        height="25.7231"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="2" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.44 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="-1" dy="-1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.698039 0 0 0 0 0.835294 0 0 0 0 0.188235 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="18.6269"
        y1="19.9999"
        x2="-9.86976"
        y2="39.1879"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DBF1C1" />
        <stop offset="0.489583" stopColor="#DBF1C1" stopOpacity="0.3" />
        <stop offset="1" stopColor="#DBF1C1" />
      </linearGradient>
    </defs>
  </svg>
)
